export default __webpack_public_path__ + "static/media/modem.c5e3dae4.png";